export const LOAD_ENUMS = 'LOAD_ENUMS'
export const LOAD_ENUMS_SUCCESS = 'LOAD_ENUMS_SUCCESS'
export const LOAD_ENUMS_FAILED = 'LOAD_ENUMS_FAILED'
